"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toggleElementClass(element, className, shouldAdd) {
    if (shouldAdd) {
        element.classList.add(className);
    }
    else {
        element.classList.remove(className);
    }
}
exports.default = toggleElementClass;
//# sourceMappingURL=toggleElementClass.js.map